import useAuthUser from "./auth-user";
import { getIsEngageAppointment } from "../utils/session-storage";

export default function useEngageStatus(
    appointmentId?: number
): {
    isEngageParticipationActive: boolean;
} {
    const [authUser] = useAuthUser();
    const engageParticipant = authUser?.engageParticipant;

    if (engageParticipant?.hasAllTestsResults === true) {
        return { isEngageParticipationActive: false };
    }

    if (appointmentId != null) {
        return {
            isEngageParticipationActive:
                engageParticipant?.appointmentIds?.includes(appointmentId) ??
                false,
        };
    }

    return {
        isEngageParticipationActive: getIsEngageAppointment(),
    };
}
